import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTranslate } from '@im/react-localization';
import TextField from '@mui/material/TextField';
import LabeledField from 'src/components/Form/LabeledField';

export default function DeactivateWarningDialog(
  props: Readonly<{
    content: string;
    handleClose: () => void;
    handleDeactivate: (reason?: string) => void;
    isLoading?: boolean;
    isReasonRequired?: boolean;
    open: boolean;
    title: string;
  }>
) {
  const translate = useTranslate();

  const [reason, setReason] = useState<string>('');
  return (
    <Dialog
      data-testid="gds-vp-deactivate-warning-dialog"
      fullWidth
      maxWidth="sm"
      onClose={props.handleClose}
      open={props.open}
      scroll="body"
    >
      <DialogTitle>
        {props.title}
        <IconButton disabled={props.isLoading} onClick={props.handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="bodycopyregular">{props.content}</Typography>
          {props.isReasonRequired && (
            <LabeledField isRequired label={translate('Common.ReasonLabel')}>
              <TextField
                data-testid="gds-vp-deactivate-reason"
                fullWidth
                maxRows={4}
                minRows={4}
                multiline
                onChange={(e) => setReason(e.target.value)}
                placeholder={translate('Common.PlaceholderEnterValue')}
              />
            </LabeledField>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="gds-vp-deactivate-warning-cancel-btb"
          disabled={props.isLoading}
          onClick={props.handleClose}
          variant="newText"
        >
          {translate('Common.Cancel')}
        </Button>
        <Button
          data-testid="gds-vp-deactivate-warning-deactivate-btn"
          disabled={props.isLoading || (props.isReasonRequired && !reason)}
          onClick={() => props.handleDeactivate(reason)}
          variant="newContained"
        >
          {translate('VendorDeals.Deactivate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
